import {ReactElement} from 'react';
import {Box, Button, Typography} from '@mui/material';
import {TFunction} from 'react-i18next';

type Props = {
  icon: ReactElement;
  name: string;
  value: string | null;
  t: TFunction;
};

export default function ResourceCard({icon, name, value, t}: Props): ReactElement {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        p: 1,
        border: '1px solid',
        borderColor: 'borderColor',
        borderRadius: '4px',
        backgroundColor: 'background.paper'
      }}
    >
      <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5}}>
        <Box sx={{display: 'inline-flex', p: 0.75}}>{icon}</Box>
        <Typography sx={{fontSize: 16, color: 'text.primary', px: 0.75, maxWidth: '100%'}}>
          {name}
        </Typography>
      </Box>
      <Box sx={{display: 'flex', justifyContent: 'space-between', gap: 1.5, width: '100%', mt: 'auto'}}>
        <Button
          size="small"
          disabled={!value}
          sx={{minWidth: 0, px: 0.75, flexShrink: 0, whiteSpace: 'nowrap', fontSize: 14}}
          {...(value ? {href: value, target: '_blank', rel: 'noopener'} : {})}
        >
          {t('common:open')}
        </Button>
        <Button
          size="small"
          onClick={() => value && navigator.clipboard.writeText(value)}
          disabled={!value}
          sx={{minWidth: 0, px: 0.75, flexShrink: 0, whiteSpace: 'nowrap', fontSize: 14}}
        >
          {t('common:copyLink')}
        </Button>
      </Box>
    </Box>
  );
}
